export default class RelatedMaterialsComponent {
	constructor() {
        const swiper = new Swiper('.slider_related_materials_component', {
            slidesPerView: 2,
            spaceBetween: 30,

			navigation: {
				nextEl: '.slider-button-next',
				prevEl: '.slider-button-prev',
			},

			pagination: {
				el: '.slider-pagination',
				clickable: true,
			},

			breakpoints: {
				0: {
				  slidesPerView: 1.3,
				},
				768: {
				  slidesPerView: 2,
				},
				1024: {
				  slidesPerView: 2,
				},
			},
		});
	}
}
new RelatedMaterialsComponent();